<template>
  <footer :class="'footer'">
    <div :class="'container'">
      <nav></nav>
      <div :class="'copyright text-center'">
        &copy; {{ new Date().getFullYear() }} <b>PwC</b>
      </div>
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style>

</style>
